<div class="head_style head-thin">
  <div class="block one"></div>
  <div class="block two"></div>
  <div class="block three"></div>
  <div class="block four"></div>
  <div class="block five"></div>
</div>
